import { Routes } from '@angular/router';
import { MaintenanceRequestPage } from './pages/maintenance-request-page/maintenance-request-page';
import { MaintenanceRequestForm } from './pages/maintenance-request-page/maintenance-request-form/maintenance-request-form';
import { LoginPage } from './pages/login-page/login-page';
import { InProcessRequest } from './pages/in-process-request/in-process-request';
import { ArchivedRequests } from './pages/archived-requests/archived-requests';
import { MaintenanceRequestDetailsPage } from './pages/maintenance-request-page/maintenance-request-details-page/maintenance-request-details-page';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'new-request',
    component: MaintenanceRequestForm,
  },
  {
    path: 'login',
    component: LoginPage,
  },
  {
    path: 'in-process',
    component: InProcessRequest,
  },
  {
    path: 'archived-requests',
    component: ArchivedRequests,
  },
  {
    path: 'maintenance-request/:id',
    component: MaintenanceRequestDetailsPage,
  },
];
